var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-body-2"},[_c('h-menu-chips'),_vm._v(" "),_c('v-row',{attrs:{"no-gutters":"","justify":"space-between","align":"center"}},[_c('v-col',[_c('h-menu-hints')],1),_vm._v(" "),(_vm.config('fastMenuEntry'))?_c('h-fast-menu-quantity',{on:{"change":function($event){return _vm.$emit('change')}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }